import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './Gateway.module.scss';
import { Link } from 'react-router-dom';

export const GatewayStepTwoSection = () => (
  <AboutPageLayout
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.stepFinalSection_1}>Join us to</div>
        <div className={styles.stepFinalSection_2}>become a part of that future.</div>
      </div>
    }
    rightContent={
      <div className={styles.finalStepContent}>
        <Link to="/join" className={styles.guideButton}>
          Choose Your Role
        </Link>
      </div>
    }
  />
);
